import { render, staticRenderFns } from "./SpecialCourseEdit.vue?vue&type=template&id=616ca182"
import script from "./SpecialCourseEdit.vue?vue&type=script&lang=js"
export * from "./SpecialCourseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports